import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-personalize-and-machine-learning-blog',
  templateUrl: './personalize-and-machine-learning-blog.component.html',
  styleUrls: ['./personalize-and-machine-learning-blog.component.css']
})
export class PersonalizeAndMachineLearningBlogComponent {
  baseUrl=Constants.baseUrl;
  constructor(
    private titleService: Title,private seoService:SeoService,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/personalize-and-machine-learning/"
  },
  "headline": "Personalisation and Machine Learning in Marketing",
  "description": "Technology is getting personalised. So surprisingly personalised that you no longer have to remember your shopping you’ve left midway- the internet reminds you anyway. Big data and Machine learning have dug deep into human interests that we don’t have to search for anything to get anywhere- it comes to you!",
  "image": "https://mitresource.com/assets/images/blogs/blog_mainimage.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2022-11-11"
}`;
   
    this._renderer2.appendChild(this._document.head, script);

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Personalisation and Machine Learning in Marketing');

    this.metaService.addTags([
      { name: 'description', content: 'Technology is getting personalised. So surprisingly personalised that you no longer have to remember your shopping you’ve left midway- the internet reminds you anyway!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Personalisation and Machine Learning in Marketing' },
      { property: 'og:url', content: 'https://mitresource.com/personalize-and-machine-learning/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/blog_mainimage.png' },
      { property: 'og:description', content: 'Technology is getting personalised. So surprisingly personalised that you no longer have to remember your shopping you’ve left midway- the internet reminds you anyway.' },
     ]);
  }
}
